import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import * as Sentry from '@sentry/react'
import { IntlayerProvider } from 'react-intlayer'
import { initializeGtmClickTracking } from './infrastructure/analytics/gtm'
import { ToastProvider } from './hooks/useToast'

Sentry.init({
  dsn: 'https://5d2bb7fa7f70af0b54163366c9a81a27@o943354.ingest.us.sentry.io/4509761560772608',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

// Initialize GTM click tracking
initializeGtmClickTracking()

// Mount the app to the hidden root element
const rootElement = document.getElementById('root')
if (rootElement) {
  createRoot(rootElement).render(
    <IntlayerProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </IntlayerProvider>,
  )
} else {
  console.error('Root element not found')
}
